
import { Route, Routes, Navigate } from "react-router-dom";
import Index from "@/pages/Index";
import { MobileQuotationsPage } from "./MobileQuotationsPage";
import { StockManagement } from "@/components/StockManagement";
import { Reports } from "@/pages/Reports";
import { StockConfig } from "@/components/StockConfig";
import { CustomerTable } from "@/components/CustomerTable";
import { QuotationView } from "@/pages/QuotationView";

export function MobileRoutes() {
  return (
    <Routes>
      <Route path="dashboard" element={<Index />} />
      <Route path="stock" element={<StockManagement />} />
      <Route path="reports" element={<Reports />} />
      <Route path="quotations" element={<MobileQuotationsPage />} />
      <Route path="settings" element={<StockConfig />} />
      <Route path="customers" element={<div className="pb-20 px-3"><CustomerTable /></div>} />
      {/* Ensure both path formats work for quotation viewing */}
      <Route path="quotation/:code" element={<QuotationView />} />
      <Route path="/quotation/:code" element={<QuotationView />} />
      <Route path="/" element={<Navigate to="dashboard" replace />} />
      <Route path="*" element={<Navigate to="dashboard" replace />} />
    </Routes>
  );
}
